export function Impressum() {
  return (
    <div className="bg-white p-5 shadow-md rounded-md max-w-3xl mx-auto">
      <a 
        href="#home"
        className="inline-block mb-6 px-3 py-1 bg-orange-100 hover:bg-orange-200 text-orange-800 rounded-md text-sm transition-colors"
      >
        ← Zurück zur Startseite
      </a>
      
      <h1 className="text-2xl font-bold mb-6 text-orange-800">Impressum</h1>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-2 text-orange-700">Inhaber und Verantwortlicher</h2>
          <address className="not-italic">
            <p>Alexander Di Bernardo</p>
            <p>Oberdorfer Straße 11a/4</p>
            <p>9554 St. Urban</p>
            <p>Österreich</p>
          </address>
        </section>
        
        <section>
          <h2 className="text-xl font-semibold mb-2 text-orange-700">Kontakt</h2>
          <p>E-Mail: alexander@di-bernardo.eu</p>
          <p>Telefon: 0650/415 45 82</p>
        </section>
        
        <section>
          <h2 className="text-xl font-semibold mb-2 text-orange-700">Informationen gemäß ECG</h2>
          <p>
            Diese Webseite dient ausschließlich der Information über die motorbezogene Versicherungssteuer in Österreich.
            Der Inhalt wurde mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der
            Inhalte kann jedoch keine Gewähr übernommen werden.
          </p>
        </section>
        
        <section>
          <h2 className="text-xl font-semibold mb-2 text-orange-700">Haftungsausschluss</h2>
          <p>
            Die Nutzung des MVS-Rechners erfolgt auf eigene Gefahr. Der Betreiber der Webseite übernimmt keine Gewähr
            für die Richtigkeit der berechneten Steuerbeträge. Die tatsächliche Steuer kann aufgrund weiterer Faktoren
            abweichen. Der MVS-Rechner dient nur zur ersten Orientierung.
          </p>
          <p className="mt-2">
            Alle Berechnungen erfolgen ohne Gewähr. Bei Fragen zur konkreten Steuerhöhe wenden Sie sich bitte an Ihr
            Finanzamt oder Ihre Versicherung.
          </p>
        </section>
      </div>
    </div>
  )
}

export default Impressum 